import NonEditableBlock from './base/non-editable-block';
import { computed } from '@ember/object';
import { htmlEscape, ternary, ternaryToProperty } from '@intercom/pulse/lib/computed-properties';
import uriEncodeAttributes from './../../lib/computed-properties/uri-encode-attributes';
import openingTag from './../../lib/computed-properties/ic-block-opening-tag';
import AlignableBlock from './mixins/alignable-block';
import { and, not, notEmpty } from '@ember/object/computed';
import Em from 'ember';
export default NonEditableBlock.extend(AlignableBlock, {
  type: 'button',
  isMedia: true,
  isButton: true,
  isLinkOnlyMode: not('config.allowButton'),
  openingTag: openingTag('linkUrl', 'text', 'id', 'align'),
  hasText: notEmpty('text'),
  hasLink: notEmpty('linkUrl'),
  hasTextAndLink: and('hasText', 'hasLink'),
  placeholderClass: ternary('hasText', '', ' hasNoText'),
  placeHolderText: ternary('config.readOnly', '', 'Enter button text'),
  textOrPlaceholder: ternaryToProperty('hasText', 'text', 'placeHolderText'),
  escapedText: htmlEscape('textOrPlaceholder'),
  closingTag: '</ic-block>',
  encodedUrl: uriEncodeAttributes('linkUrl'),
  innerHtml: computed('_zeroWidthSpace', '_paragraphInserter', 'baseClass', 'placeholderClass', 'escapedText', function () {
    return `${this._zeroWidthSpace}${this._paragraphInserter}<a class="${this.baseClass}${this.placeholderClass}" href="#" contenteditable="false">${this.escapedText}</a>${this._paragraphInserter}${this._zeroWidthSpace}`;
  }),
  baseClass: ternary('isLinkOnlyMode', 'link-only-mode', 'intercom-h2b-button'),
  serialized: Em.computed('linkUrl', 'text', 'align', 'type', 'allowAlignment', function () {
    let serialized = {
      type: this.get('type'),
      linkUrl: this.get('linkUrl'),
      text: this.get('text')
    };
    if (this.get('config.allowAlignment')) {
      serialized.align = this.get('align');
    }
    return serialized;
  }),
  cleanData() {
    //TODO: GJ: tests
    this.cleanUrl('linkUrl');
  }
});